import { useAppSelector } from 'hooks/useAppStore';
import { useStudentProfile } from './useStudentProfile';
import { resolveLearnerDisplayName } from '../utils/learnerDisplayName';

/** Resolved learner display name (profile nickname, then email prefix). */
export function useLearnerDisplayName() {
  const { profile } = useStudentProfile();
  const platformUser = useAppSelector((s) => s.auth.user);
  return resolveLearnerDisplayName(profile, platformUser);
}
